var map = {
	"./geography/argentina.svg": "7d25",
	"./geography/brazil.svg": "26fc",
	"./geography/chile.svg": "68ab",
	"./geography/colombia.svg": "179e",
	"./geography/italy.svg": "1d9e",
	"./geography/peru.svg": "f30f",
	"./geography/romania.svg": "8123",
	"./geography/spain.svg": "85f8",
	"./geography/unitedStates.svg": "9a97",
	"./urbanEnvironments/buildings.svg": "42b4",
	"./urbanEnvironments/cityDistricts.svg": "5e7a",
	"./urbanEnvironments/crossRoads.svg": "6a92",
	"./urbanEnvironments/culturalSites.svg": "ea12",
	"./urbanEnvironments/hospital.svg": "e643",
	"./urbanEnvironments/parkings.svg": "704a",
	"./urbanEnvironments/publicTransport.svg": "7106",
	"./urbanEnvironments/schoolUniversities.svg": "aea8",
	"./urbanEnvironments/shoppingAreas.svg": "3ce3",
	"./urbanEnvironments/sportFacilities.svg": "1bf7",
	"./urbanEnvironments/streets.svg": "0945"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca89";